import React from 'react';

import ComponentDashbordPage from '../ComponentDashbordPage';

const DashboardPage = (): JSX.Element => <ComponentDashbordPage />;

export default DashboardPage;
